module.exports = __webpack_public_path__ + "static/media/GolosText-ExtraBold.58f9e3de.ttf";